import React from 'react'
import SkeletonTile from '../SkeletonTile/SkeletonTile'
export const SkeletonLoader = ({ size = 2 , testId}): React.JSX.Element => {
  return (
    <div data-test-id={testId}>
      {Array(size)
        .fill(1)
        .map((data, index) => {
          return (
            <div className="flex-v-center" key={index}>
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={15}
                tileWidth={450}
                tileRadius={6}
                tileBottomSpace={12}
                tileTopSpace={12}
                tileleftSpace={18}
              />
            </div>
          )
        })}
    </div>
  )
}
